module.exports = "/_next/static/images/a171d7e183f403d6b352d2a4663f6e13-word-cup-md-3x.png.webp";